import { useMutation } from "@tanstack/react-query";
import { api } from "shared/api";
import { UpdateStandardProductOrderPayload } from "shared/api/middleware-api-client";

const updateStandardProductOrderInAPI = async ({
  orderId,
  payload,
}: {
  orderId: string;
  payload: UpdateStandardProductOrderPayload;
}) => {
  const res = await api().gersUpdateStandardProductOrder(orderId, payload);
  return res.data;
};

export const useUpdateStandardProductOrder = () => {
  const updateOrder = useMutation(updateStandardProductOrderInAPI);

  const updateOrderAsync = async (
    orderId: string,
    payload: UpdateStandardProductOrderPayload,
  ) => {
    try {
      // Trigger the mutation asynchronously
      await updateOrder.mutateAsync({
        orderId,
        payload,
      });
    } catch (error) {}
  };

  // Return an object containing the mutation object and the async function
  return {
    updateOrder,
    updateOrderAsync,
    isUpdateLoading: updateOrder.isLoading,
  };
};
